var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    background: _vm.variables[(_vm.style + "-container-background")],
    '--background': _vm.variables[(_vm.style + "-top-bar-background")],
    '--menuColor': _vm.variables[(_vm.style + "-menu-color")],
    '--topColor': _vm.variables[(_vm.style + "-tab-color")],
  }),attrs:{"id":"app"}},[(_vm.isEnvironmentValid)?_c('keep-alive',{attrs:{"include":['MyTask', 'TemplatePreview', 'homePage']}},[_c('router-view')],1):_c('HtGuide')],1)}
var staticRenderFns = []

export { render, staticRenderFns }